import React, { useState, useEffect } from 'react';
import '../../../Styles/Notification/Notification.css';
import { useTranslation } from 'react-i18next';
import { jwtDecode } from 'jwt-decode'; // Using named export from jwt-decode
import CloseIcon from '../../../assets/svg/closeIcon';
import { useNotifications } from './NotificationContext';

function Notification({ closeOverlay }) {
    const { t } = useTranslation();
    const [notification, setNotification] = useState([]);
    const [currentUserId, setCurrentUserId] = useState(null);
    const [loading, setLoading] = useState(true);
    const[role,setRole]=useState([]);

    const {
        removeNotification,
        setNotificationCount,
        notifcationvalue,
        updateNotificationStatus,
        markAllAsRead,
    } = useNotifications();

    useEffect(() => {
        const token = localStorage.getItem('authToken');
        

        if (token) {
            try {
                const decoded = jwtDecode(token);
                console.log('my token account:',decoded);

                if (decoded && decoded.id) {
                    setCurrentUserId(decoded.id);
                    setRole(decoded.role);
                }
            } catch (error) {
                console.error('Failed to decode token:', error);
            }
        } else {
            console.warn('No token found in localStorage under key \'authToken\'.');
        }
    }, []);
    console.log('role,id',role,currentUserId);
    const updateSingleNotification = async (id, type) => {
        if (!currentUserId) {
            console.warn('Cannot update notification: currentUserId is null.');
            return;
        }

        try {
            await updateNotificationStatus(currentUserId, type, id);

        } catch (error) {
            console.error(`Error updating single notification ${id}:`, error);
        }
    };

    useEffect(() => {
        if (!currentUserId) return;

        setLoading(true);
        if (notifcationvalue && notifcationvalue.length > 0) {
            setNotification(notifcationvalue);
            setLoading(false);
        } else {
            setNotification([]);
            removeNotification();
        }
        setLoading(false);
    }, [currentUserId, notifcationvalue]);

    const markAllAsReadHandler = async () => {
        if (!currentUserId) {
            console.warn(
                'Cannot mark notifications as read because currentUserId is null.'
            );
            return;
        }

        try {
            await markAllAsRead(currentUserId,role);

        } catch (error) {
            console.error('Error marking notifications as read:', error);
        }
    };

    const clearNotifications = async () => {
        if (!currentUserId) {
            console.warn('Cannot clear notifications because currentUserId is null.');
            return;
        }

        try {
            await removeNotification(currentUserId);
            setNotification([]);
            setNotificationCount(0);

        } catch (error) {
            console.error('Error clearing notifications:', error);
        }
    };

    function formatDateToDDMMYYYY(isoString) {
        const date = new Date(isoString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
    }

    return (
        <div className='notification-container-overall'>
            <div className='notification-title-container'>
                <h1 className='main-title-notification'>
                    {t('notification.notifications-title')}
                </h1>
                <div className='close-container'>
                    <div className='mark-read'>
                        <p className='mark-all-as-read' onClick={markAllAsReadHandler}>
                            {t('notification.mark-all-as-read-title')}
                        </p>
                        <p className='mark-all-as-read' onClick={clearNotifications}>
                            {t('notification.clear-all-title')}
                        </p>
                    </div>

                    <CloseIcon
                        height='25'
                        width='25'
                        onClick={closeOverlay}
                        color='black'
                    />
                </div>
            </div>
            <div className='break-line'></div>
            <div className='notification-messages-main-container'>
                {loading ? (
                    <p>Loading...</p>
                ) : notification.length > 0 ? (
                    notification.map((item, index) => (
                        <div key={index} className='notification-messages-container'>
                            <div className='title-time-and-date-container'>
                                <h1
                                    className={`notification-title ${
                                        item?.is_read == true && 'title-color'
                                    }`}
                                >
                                    {item?.notes && item?.notes?.length > 35
                                        ? item?.notes.slice(0, 35) + '...'
                                        : item?.notes}
                                </h1>
                                <p
                                    className={`date-in-notification ${
                                        item?.is_read == true && 'title-color'
                                    }`}
                                >
                                    {formatDateToDDMMYYYY(item?.created_at)}
                                </p>
                            </div>
                            <p
                                className={`notification-description ${
                                    item?.is_read == true && 'title-color'
                                }`}
                            >
                                {item?.notes && item?.notes?.length > 90
                                    ? item?.notes.slice(0, 90) + '...'
                                    : item?.notes}
                                {item?.is_read == false && (
                                    <button
                                        onClick={() =>
                                            updateSingleNotification(item?.ID, item?.type)
                                        }
                                        disabled={item?.is_read === true}
                                        className='notification-button'
                                    >
                      Mark as Read
                                    </button>
                                )}
                            </p>
                            
                        </div>
                    ))
                ) : (
                    <div className='no-notification-container'>
                        <p>No notifications available</p>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Notification;